import { createSelector } from 'reselect';

export const containerState = (state) => state.Session;

export const isImagesPreloadForced = createSelector(
	containerState,
	(state) => state.forceAllImagesPreloaders,
);
